import { Link } from "react-router-dom";
import { BrandWordmark } from "./BrandWordmark";

/**
 * elabor8 brand mark — the top of the sidebar, seated ABOVE the workspace
 * switcher (design shell §1.1). It is the app's home affordance: clicking it
 * returns to the workspace picker ("/"), matching the "All workspaces" nav
 * pattern in {@link WorkspaceSwitcher}.
 *
 * The mark itself is the shared {@link BrandWordmark} (one source of truth for
 * the theme-aware wordmark, also used by login + the workspace picker).
 *
 * ⚠️ The sidebar DOES have a collapsed state now — `@norkron/web-sidebar`'s 48px
 * icon rail (Cmd/Ctrl+B, or the resize handle dragged in), which replaced the
 * fixed `3px 236px 1fr` shell grid this comment used to cite. A ~5:1 wordmark
 * cannot render in 48px, so `styles/chrome.css` crops it to its leading glyph
 * under the lib's `.sidebar--collapsed` state class. That rule keys off the lib's
 * class rather than a prop, so there is no second source of truth for
 * "am I collapsed" and this component stays presentational.
 */

export function SidebarLogo() {
  return (
    <Link to="/" className="sidebar-logo" aria-label="elabor8 — all workspaces">
      <BrandWordmark
        className="sidebar-logo__img"
        testId="sidebar-logo"
        height={22}
      />
    </Link>
  );
}
